export { CategoryDetailPage } from './view/category-detail-page';
